import React from 'react';
import SchemaEnforcementTable from './SchemaEnforcementTable';
import SchemaEnforcementTableContextProvider from '../SchemaEnforcementTableContextProvider';
import { usePipelinePageContext } from '../PipelinePageContextProvider';

export default function SchemaEnforcementItem() {
  const { pipeline } = usePipelinePageContext();
  const {
    id,
    name,
    writekey,
    cluster: { id: clusterId },
  } = pipeline;

  const schemaEnforcementTablePipeline = {
    id,
    name,
    writekey,
    clusterId,
  };

  return (
    <SchemaEnforcementTableContextProvider pipeline={schemaEnforcementTablePipeline}>
      <SchemaEnforcementTable />
    </SchemaEnforcementTableContextProvider>
  );
}
